import { inject } from "mobx-react";

import { CatalogKindTypes, CatalogProps, generateCatalogUrl, QueryProps } from "@ihr-radioedit/inferno-core";
import "./Catalog.style.scss";

export const Catalog = inject("store")(
  ({ store, value, query, isPodcastEmbed }: { query?: QueryProps } & CatalogProps) => {
    if (!store || !value) {
      return null;
    }
    const { id, kind, description, related_id } = value;

    if (!id || !kind) {
      return null;
    }

    const catalogUrl = generateCatalogUrl(
      { national_site_url: store.env.NATIONAL_SITE_URL, node_env: store.env.NODE_ENV },
      {
        id,
        related_id: related_id || "",
        kind: (CatalogKindTypes as any)[kind],
        embed: true,
        query: {
          ...query,
          keyid: isPodcastEmbed ? store.env.PODCAST_EMBED_KEYID : store.request.query?.keyid,
        },
      },
    );

    if (catalogUrl) {
      const title = description || "Music Catalog";
      return (
        <div className="component-catalog-container">
          <iframe src={catalogUrl} title={title} />
        </div>
      );
    }

    return null;
  },
);

export default Catalog;
